import { RouteConfig } from "vue-router";

export const REmployerRoleTemplate: RouteConfig = {
  path: ":id(\\d+)",
  name: "EmployerRole",
  component: () =>
    import(
      /* webpackChunkName: "employer-role" */
      "./VEmployerRoleTemplate.vue"
    ),
  meta: {
    title: "Job templates",
    backLink: "/roles",
  },
};
